/*

Slight deviation from the style-guide

- renamed: `purple-600` to `purple`
- renamed: `green` to `success`
- renamed: `red` to `danger`

*/
export const purple = '#5E3393'
export const white = '#FFFFFF'
export const transparent = 'transparent'

export const palette = {
  purple,
  white,
  transparent,
  accent: {
    50: '#FFFCF1',
    100: '#FFF9E2',
    200: '#FFF4CE',
    300: '#FFEDAE',
    400: '#FFE27B',
    500: '#FFD53F',
    600: '#FFC700',
    700: '#FFBD3E',
    800: '#F2B33B',
  },
  primary: {
    50: '#F3F4FB',
    100: '#E9EAF2',
    200: '#D3D4E2',
    300: '#C0C1D9',
    400: '#9095C0',
    500: '#5B619E',
    600: '#232D7C',
    700: '#1E276C',
    800: '#161D50',
  },
  secondary: {
    50: '#EDF7FE',
    100: '#E7F5FF',
    200: '#CDEAFF',
    300: '#B2DFFF',
    400: '#80C9FF',
    500: '#41AFFF',
    600: '#0094FF',
    700: '#0084E3',
    800: '#006BB0',
  },
  success: {
    50: '#F4FFF5',
    100: '#DDF8DE',
    200: '#C4F2C6',
    300: '#ABE8AD',
    400: '#72D776',
    500: '#02C003',
    600: '#00AB01',
    700: '#00960A',
    800: '#008609',
  },
  danger: {
    50: '#FFF2F2',
    100: '#FFE5E7',
    200: '#FDCAD3',
    300: '#F5B3BB',
    400: '#F57D8B',
    500: '#F03B51',
    600: '#E8001C',
    700: '#D00019',
    800: '#BB0010',
  },
  gray: {
    50: '#F9F9F9',
    100: '#F5F4F4',
    200: '#EAEAEA',
    300: '#E0DFE2',
    400: '#CDCBD0',
    500: '#B3B0B8',
    600: '#8F8D94',
    700: '#65656D',
    800: '#282933',
  },
}
